__turbopack_context__.v({
  "app_light_theme": "plastic-card-promotion-module-scss-module__slBYjG__app_light_theme",
  "card": "plastic-card-promotion-module-scss-module__slBYjG__card",
  "card__background": "plastic-card-promotion-module-scss-module__slBYjG__card__background",
  "card__buttonLink": "plastic-card-promotion-module-scss-module__slBYjG__card__buttonLink",
  "card__content": "plastic-card-promotion-module-scss-module__slBYjG__card__content",
  "card__text": "plastic-card-promotion-module-scss-module__slBYjG__card__text",
  "card__title": "plastic-card-promotion-module-scss-module__slBYjG__card__title",
});
